import { PhoneNumber, parsePhoneNumber } from "libphonenumber-js";

export class TextUtil {
  public static getNameFromUrl(url: string): string {
    if (!url) {
      return null;
    }
    const parts = url.split("/");
    if (!parts || parts.length < 1) {
      return null;
    }
    return parts[parts.length - 1];
  }

  public static getCountryNameList() {
    return [
      "AFGHANISTAN",
      "ALBANIA",
      "ALGERIA",
      "AMERICAN SAMOA",
      "ANDORRA",
      "ANGOLA",
      "ANGUILLA",
      "ANTARCTICA",
      "ANTIGUA AND BARBUDA",
      "ARGENTINA",
      "ARMENIA",
      "ARUBA",
      "AUSTRALIA",
      "AUSTRIA",
      "AZERBAIJAN",
      "BAHAMAS",
      "BAHRAIN",
      "BANGLADESH",
      "BARBADOS",
      "BELARUS",
      "BELGIUM",
      "BELIZE",
      "BENIN",
      "BERMUDA",
      "BHUTAN",
      "BOLIVIA",
      "BONAIRE",
      "BOSNIA AND HERZEGOVINA",
      "BOTSWANA",
      "BOUVET ISLAND",
      "BRAZIL",
      "BRITISH INDIAN OCEAN TERRITORY",
      "BRITISH VIRGIN ISLANDS",
      "BRUNEI DARUSSALAM",
      "BULGARIA",
      "BURKINA FASO",
      "BURUNDI",
      "CAMBODIA",
      "CAMEROON",
      "CANADA",
      "CAPE VERDE",
      "CAYMAN ISLANDS",
      "CENTRAL AFRICAN REPUBLIC",
      "CHAD",
      "CHILE",
      "CHINA",
      "CHRISTMAS ISLAND",
      "COCOS (KEELING) ISLANDS",
      "COLOMBIA",
      "COMOROS",
      "CONGO",
      "COOK ISLANDS",
      "COSTA RICA",
      "COTE D'IVOIRE",
      "CROATIA",
      "CUBA",
      "CURACAO",
      "CYPRUS",
      "CZECH REPUBLIC",
      "DEMOCRATIC REPUBLIC OF THE CONGO",
      "DENMARK",
      "DJIBOUTI",
      "DOMINICA",
      "DOMINICAN REPUBLIC",
      "ECUADOR",
      "EGYPT",
      "EL SALVADOR",
      "EQUATORIAL GUINEA",
      "ERITREA",
      "ESTONIA",
      "ETHIOPIA",
      "FALKLAND ISLANDS (MALVINAS)",
      "FAROE ISLANDS",
      "FIJI",
      "FINLAND",
      "FRANCE",
      "FRENCH GUIANA",
      "FRENCH POLYNESIA",
      "FRENCH SOUTHERN TERRITORIES",
      "GABON",
      "GAMBIA",
      "GEORGIA",
      "GERMANY",
      "GHANA",
      "GIBRALTAR",
      "GREECE",
      "GREENLAND",
      "GRENADA",
      "GUADELOUPE",
      "GUAM",
      "GUATEMALA",
      "GUERNSEY",
      "GUINEA",
      "GUINEA-BISSAU",
      "GUYANA",
      "HAITI",
      "HEARD ISLAND AND MCDONALD ISLANDS",
      "HOLY SEE (VATICAN CITY STATE)",
      "HONG KONG",
      "HUNGARY",
      "ICELAND",
      "INDIA",
      "INDONESIA",
      "IRAN",
      "IRAQ",
      "IRELAND",
      "ISLE OF MAN",
      "ISRAEL",
      "ITALY",
      "JAMAICA",
      "JAPAN",
      "JERSEY",
      "JORDAN",
      "KAZAKHSTAN",
      "KENYA",
      "KIRIBATI",
      "NORTH KOREA",
      "SOUTH KOREA",
      "KUWAIT",
      "KYRGYZSTAN",
      "LAOS",
      "LATVIA",
      "LEBANON",
      "LESOTHO",
      "LIBERIA",
      "LIBYA",
      "LIECHTENSTEIN",
      "LITHUANIA",
      "LUXEMBOURG",
      "MACAO",
      "NORTH MACEDONIA",
      "MADAGASCAR",
      "MALAWI",
      "MALAYSIA",
      "MALDIVES",
      "MALI",
      "MARSHALL ISLANDS",
      "MARTINIQUE",
      "MAURITANIA",
      "MAURITIUS",
      "MAYOTTE",
      "MEXICO",
      "MICRONESIA",
      "MOLDOVA",
      "MONACO",
      "MONGOLIA",
      "MONTENEGRO",
      "MONTSERRAT",
      "MOROCCO",
      "MOZAMBIQUE",
      "MYANMAR",
      "NAMIBIA",
      "NAURU",
      "NEPAL",
      "NETHERLANDS",
      "NEW CALEDONIA",
      "NEW ZEALAND",
      "NICARAGUA",
      "NIGER",
      "NIGERIA",
      "NIUE",
      "NORFOLK ISLAND",
      "NORTHERN MARIANA ISLANDS",
      "NORWAY",
      "OMAN",
      "PAKISTAN",
      "PALAU",
      "PALESTINE",
      "PANAMA",
      "PAPUA NEW GUINEA",
      "PARAGUAY",
      "PERU",
      "PHILIPPINES",
      "PITCAIRN ISLANDS",
      "POLAND",
      "PORTUGAL",
      "PUERTO RICO",
      "QATAR",
      "REUNION",
      "ROMANIA",
      "RUSSIAN FEDERATION",
      "RWANDA",
      "SAINT BARTHELEMY",
      "SAINT HELENA",
      "SAINT KITTS AND NEVIS",
      "SAINT LUCIA",
      "SAINT MARTIN (FRENCH PART)",
      "SAINT PIERRE AND MIQUELON",
      "SAINT VINCENT AND THE GRENADINES",
      "SAMOA",
      "SAN MARINO",
      "SAO TOME AND PRINCIPE",
      "SAUDI ARABIA",
      "SENEGAL",
      "SERBIA",
      "SEYCHELLES",
      "SIERRA LEONE",
      "SINGAPORE",
      "SINT MAARTEN (DUTCH PART)",
      "SLOVAKIA",
      "SLOVENIA",
      "SOLOMON ISLANDS",
      "SOMALIA",
      "SOUTH AFRICA",
      "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS",
      "SOUTH SUDAN",
      "SPAIN",
      "SRI LANKA",
      "SUDAN",
      "SURINAME",
      "SVALBARD AND JAN MAYEN",
      "ESWATINI (SWAZILAND)",
      "SWEDEN",
      "SWITZERLAND",
      "SYRIA",
      "TAIWAN",
      "TAJIKISTAN",
      "THAILAND",
      "TIMOR-LESTE",
      "TOGO",
      "TOKELAU",
      "TRINIDAD AND TOBAGO",
      "TUNISIA",
      "TURKEY",
      "TURKMENISTAN",
      "TURKS AND CAICOS ISLANDS",
      "TUVALU",
      "UGANDA",
      "UKRAINE",
      "UNITED ARAB EMIRATES",
      "UNITED KINGDOM",
      "TANZANIA",
      "UNITED STATES",
      "URUGUAY",
      "US VIRGIN ISLANDS",
      "UZBEKISTAN",
      "VANUATU",
      "VENEZUELA",
      "VIETNAM",
      "WALLIS AND FUTUNA",
      "WESTERN SAHARA",
      "YEMEN",
      "ZAMBIA",
      "ZIMBABWE",
    ];

    // return ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia &amp; Herzegovina", "Botswana", "Brazil", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Cape Verde", "Cayman Islands", "Chad", "Chile", "China", "Colombia", "Congo", "Cook Islands", "Costa Rica", "Cote D Ivoire", "Croatia", "Cruise Ship", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Polynesia", "French West Indies", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kuwait", "Kyrgyz Republic", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Mauritania", "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Pierre &amp; Miquelon", "Samoa", "San Marino", "Satellite", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "South Africa", "South Korea", "Spain", "Sri Lanka", "St Kitts &amp; Nevis", "St Lucia", "St Vincent", "St. Lucia", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor L'Este", "Togo", "Tonga", "Trinidad &amp; Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks &amp; Caicos", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "Uruguay", "Uzbekistan", "Venezuela", "Vietnam", "Virgin Islands (US)", "Yemen", "Zambia", "Zimbabwe"];
  }

  public static getStatesOfIndia() {
    return [
      "Andaman and Nicobar Islands",
      "Andhra Pradesh",
      "Arunachal Pradesh",
      "Assam",
      "Bihar",
      "Chandigarh",
      "Chhattisgarh",
      "Dadra and Nagar Haveli",
      "Daman and Diu",
      "Delhi",
      "Goa",
      "Gujarat",
      "Haryana",
      "Himachal Pradesh",
      "Jammu and Kashmir",
      "Jharkhand",
      "Karnataka",
      "Kerala",
      "Ladakh",
      "Lakshadweep",
      "Madhya Pradesh",
      "Maharashtra",
      "Manipur",
      "Meghalaya",
      "Mizoram",
      "Nagaland",
      "Odisha",
      "Puducherry",
      "Punjab",
      "Rajasthan",
      "Sikkim",
      "Tamil Nadu",
      "Telangana",
      "Tripura",
      "Uttar Pradesh",
      "Uttarakhand",
      "West Bengal"
    ];
  }

  public static getTimePurposeOfVisitOptions() {
    return [
      "Leisure",
      "Official",
      "Business",
      "Conference",
      "Study",
      "Spiritual",
      "Wedding",
      "Others"
    ];
  }

  public static getTimeCountryOptions() {
    return [
      "India",
      "Afghanistan",
      "Albania",
      "Algeria",
      "Argentina",
      "Armenia",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahrain",
      "Bangladesh",
      "Belarus",
      "Belgium",
      "Bhutan",
      "Brazil",
      "Bulgaria",
      "Cambodia",
      "Canada",
      "Chile",
      "China",
      "Colombia",
      "Croatia",
      "Cyprus",
      "Czech Republic",
      "Denmark",
      "Egypt",
      "Estonia",
      "Finland",
      "France",
      "Georgia",
      "Germany",
      "Greece",
      "Hungary",
      "Iceland",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland",
      "Israel",
      "Italy",
      "Japan",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kuwait",
      "Kyrgyzstan",
      "Laos",
      "Latvia",
      "Lebanon",
      "Lithuania",
      "Luxembourg",
      "Malaysia",
      "Maldives",
      "Malta",
      "Mauritius",
      "Mexico",
      "Moldova",
      "Mongolia",
      "Morocco",
      "Myanmar",
      "Nepal",
      "Netherlands",
      "New Zealand",
      "Nigeria",
      "Norway",
      "Oman",
      "Pakistan",
      "Philippines",
      "Poland",
      "Portugal",
      "Qatar",
      "Romania",
      "Russian Federation",
      "Saudi Arabia",
      "Singapore",
      "Slovakia",
      "Slovenia",
      "South Africa",
      "South Korea",
      "Spain",
      "Sri Lanka",
      "Sweden",
      "Switzerland",
      "Syrian Arab Republic",
      "Taiwan",
      "Tajikistan",
      "Thailand",
      "Turkey",
      "Turkmenistan",
      "Ukraine",
      "United Arab Emirates",
      "United Kingdom",
      "United States",
      "Uzbekistan",
      "Vietnam",
      "Yemen",
      "Others"
    ];
  }

  public static getPhoneNumberMasked(phone: string) {
    if (!phone || phone.length < 6) {
      return null;
    }

    let maskedPhone = `${phone.charAt(0)}${phone.charAt(1)}`;
    let maskedCharLength = phone.length - 5;
    while (maskedCharLength > 0) {
      maskedPhone += "X";
      maskedCharLength--;
    }
    maskedPhone += `${phone.charAt(phone.length - 3)}${phone.charAt(
      phone.length - 2
    )}${phone.charAt(phone.length - 1)}`;
    return maskedPhone;
  }

  public static removeAllSpaces(text: string) {
    return text?.replace(/ +/g, "");
  }


  public static getFormattedPhoneNumber(phone: string) {
    try {
      const phoneNumber: PhoneNumber = parsePhoneNumber(`+${phone}`);
      return `+${phoneNumber.countryCallingCode} ${phoneNumber.nationalNumber}`;
    } catch (e) {
      return phone
    }
  }
}
